import { useState } from 'react';

import { InfiniteScroll, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import DroneDetailsDrawer from 'components/DroneDetailsDrawer';
import Grid from 'components/Grid';
import GridText from 'components/text/GridText';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import DronesGridCard from './components/DronesGridCard';
import { INITIAL_REFRESH_TOKEN, TEST_ID } from './constants';
import type { DroneResponse, FunctionComponent, Props, WearRefreshTokens } from './types';

import styles from './styles.module.scss';

const DronesGrid: FunctionComponent<Props> = ({
    className = '',
    onNext,
    rows = [],
    testId = TEST_ID
}) => {
    const { LOADING } = useTranslation();

    const { endingMessage, fetchNext, hasNextPage } = useData({ onNext, rows });

    const [selectedDrone, setSelectedDrone] = useState<DroneResponse | null>(null);
    const [wearRefreshTokens, setWearRefreshTokens] = useState<WearRefreshTokens>({});

    const handleClose = () => setSelectedDrone(null);

    const handleServiceSaved = () => {
        if (!selectedDrone) {
            return;
        }

        setWearRefreshTokens(currentTokens => ({
            ...currentTokens,
            [selectedDrone.id]: (currentTokens[selectedDrone.id] ?? INITIAL_REFRESH_TOKEN) + 1
        }));
    };

    return (
        <VerticalContainer className={`${className} ${styles.dronesGrid}`} testId={testId}>
            <InfiniteScroll
                endingMessage={
                    <Wrapper className={styles.wrapper}>
                        <GridText text={endingMessage} />
                    </Wrapper>
                }
                loader={
                    <Wrapper className={styles.wrapper}>
                        <GridText text={LOADING} />
                    </Wrapper>
                }
                className={styles.infiniteScroll}
                fetchNextPage={fetchNext}
                hasNextPage={hasNextPage}>
                <Grid className={styles.grid}>
                    {rows.map(drone => (
                        <DronesGridCard
                            drone={drone}
                            key={drone.id}
                            onClick={() => setSelectedDrone(drone)}
                            refreshToken={wearRefreshTokens[drone.id]}
                        />
                    ))}
                </Grid>
            </InfiniteScroll>

            {selectedDrone && (
                <DroneDetailsDrawer
                    drone={selectedDrone}
                    onClose={handleClose}
                    onServiceSaved={handleServiceSaved}
                />
            )}
        </VerticalContainer>
    );
};

export default DronesGrid;
